import styled from '@emotion/styled';
import * as RadixPopover from '@radix-ui/react-popover';
import { vars } from '@teamsparta/stack-tokens';

export const Content = styled(RadixPopover.Content)`
  background-color: white;
  border-radius: 8px;
  padding: 8px;
  background-color: ${vars.neutral[100]};
  box-shadow: 0px 10px 16px 0px rgba(20, 22, 23, 0.24);
  border: 1px solid ${vars.neutral[80]};
`;
